import LabsPage from "./labs.page"

export default LabsPage;
